import { connect } from 'react-redux'
import closeModal from '../../actions/Modals/closeModal'
import UpdateModal from './UpdateModal'

export default connect(
  null,
  dispatch => ({
    close: id => dispatch(closeModal(id)),
  }),
)(UpdateModal)
